const THREE = require('three')
import listener from './listener'
import {loadingManager, load, registerSize} from './loader'
import {TweenMax, Cubic} from 'gsap'

export const data = {
  stage0: {
    url: require('assets/sounds/music/stage0.mp3'),
    size: 157209
  },
  stage1: {
    url: require('assets/sounds/music/stage1.mp3'),
    size: 157209
  },
  stage2_fast: {
    url: require('assets/sounds/music/stage2_fast.mp3'),
    size: 157209
  },
  airport: {
    url: require('assets/sounds/music/airport.mp3'),
    size: 157209
  },
  end_fast: {
    url: require('assets/sounds/music/end_fast.mp3'),
    size: 141465
  },
  results: {
    url: require('assets/sounds/music/results.mp3'),
    size: 157209
  }
}
export default data



// CREATE AUDIO
let loader = new THREE.AudioLoader(loadingManager)
for (let key in data) {
  let _data = data[key]

  // CREATE AUDIO OBJECT
  _data.audio = new THREE.Audio(listener)

  // LOAD
  registerSize(_data.url, _data.size)


}



// LOAD
export let loaded = false
export let checkAllLoaded = function () {
  for (let key in data) {
    let _data = data[key]
    if (!_data.buffer) return false
  }
  loaded = true
  // preplayAudio()
  return true
}
export const loadAll = function () {
  for (let key in data) {
    // console.log(key)
    let _data = data[key]
    load(_data.url, null, (results)=> {
      _data.buffer = results[0]
      _data.audio.setBuffer(results[0])
      _data.audio.setLoop(true)
      _data.audio.playbackRate = 1

      // PRE PLAY ONCE
      _data.audio.setVolume(0.0001)
      _data.audio.play()
      // _data.audio.stop()
      // _data.audio.setVolume(_data.volume || 1)

      checkAllLoaded()
    })
  }
}

loadAll()

// export const preplayAudio = function () {
//   for ()
//       // PRE PLAY ONCE
//       _data.audio.setVolume(0)
//       _data.audio.play()
//       _data.audio.stop()
//       _data.audio.setVolume(_data.volume || 1)
// }



// STAET
export let state = {
  currentId: null,
  playing: false,
  playbackRate: 1
}

export const play = function (id) {


  state.playing = true
  if (state.currentId === id) return
  if (!data.hasOwnProperty(id)) return

  let prevAudio = null
  if (state.currentId !== null) {
    const prevObj = data[state.currentId]
    if (prevObj) prevAudio = prevObj.audio
  }
  state.currentId = id
  let nextAudio = data[state.currentId].audio

  let prevTime = 0
  if (prevAudio !== null) {
    prevTime = prevAudio.context.currentTime
    prevAudio.fadeTo(0, 0.3)
    nextAudio.setPlaybackRate(prevAudio.getPlaybackRate())
  }
  nextAudio.startTime = prevTime
  nextAudio.fadeTo(0.4, 0.3)

}

export const stop = function () {
  if (!state.playing) return
  state.playing = false
  for (let key in data) {
    let _data = data[key]
    _data.audio.stop()
  }
}


export const animRate = function (rate, time = 2) {
  if (state.currentId === null) return
  TweenMax.to(state, time, {
    playbackRate: rate,
    ease: Cubic.easeIn,
    onUpdateParams: ['{self}'],
    onUpdate: (tween)=> {
      let audio = data[state.currentId].audio
      audio.setPlaybackRate(state.playbackRate)
    }
  })
}





// WEBPACK FOOTER //
// ./src/components/game/music.js